/**
 * Administration: reporting, communication and the audit surfaces.
 *
 * Part of the route table (see ./index.ts). Split by domain so adding a
 * screen touches one small file instead of one long one.
 */
import { lazy } from "react";
import type { AppRoute } from "./types";

export const ADMIN_ROUTES: AppRoute[] = [
  {
    path: "/reports",
    title: "Rapports",
    component: lazy(() => import("@/pages/reports/ReportsPage")),
    perms: ["finance.report.view", "academics.report.teacher_performance.view"],
    nav: { label: "Rapports", order: 6, mobile: 5, group: "Administration" },
  },
  {
    path: "/notifications",
    title: "Notifications",
    component: lazy(() => import("@/pages/notifications/NotificationsPage")),
    nav: { label: "Notifications", order: 55, group: "Mon compte" },
  },
  {
    path: "/inbox",
    title: "Messagerie",
    component: lazy(() => import("@/pages/inbox/InboxPage")),
    perms: ["comm.conversation.list"],
    nav: { label: "Messagerie", order: 3.6, group: "Administration" },
  },
  {
    path: "/library",
    title: "Bibliothèque",
    component: lazy(() => import("@/pages/library/LibraryPage")),
    perms: ["library.document.list"],
    nav: { label: "Bibliothèque", order: 51, group: "Administration" },
  },
  {
    path: "/timeline",
    title: "Chronologie",
    component: lazy(() => import("@/pages/timeline/TimelinePage")),
    perms: ["admin.timeline.list"],
    nav: { label: "Chronologie", order: 52, group: "Administration" },
  },
  {
    path: "/fraud-signals",
    title: "Signaux de fraude",
    component: lazy(() => import("@/pages/fraud-signals/FraudSignalsPage")),
    perms: ["fraud.signals.view"],
    nav: { label: "Signaux de fraude", order: 53, group: "Administration" },
  },
  {
    path: "/risk-center",
    title: "Centre de risques",
    component: lazy(() => import("@/pages/risk-center/RiskCenterPage")),
    perms: ["fraud.signals.view"],
    nav: { label: "Centre de risques", order: 54, group: "Administration" },
  },
  {
    path: "/duties",
    title: "Qui n'a pas fait quoi ?",
    component: lazy(() => import("@/pages/duties/DutiesPage")),
    perms: ["duty.view_dashboard"],
    nav: { label: "Qui n'a pas fait quoi ?", order: 56, group: "Administration" },
  },
  {
    // Role-gated rather than permission-gated: this list spans organisations,
    // so there is no org-scoped code that could express it.
    path: "/platform-schools",
    title: "Écoles (plateforme)",
    component: lazy(() => import("@/pages/platform-schools/PlatformSchoolsPage")),
    roles: ["platform_admin"],
    nav: { label: "Écoles (plateforme)", order: 57, group: "Administration" },
  },
];
